import { styled } from '../../../theme/stitches.config';

export const SMPKnockoutMobileContainer = styled.withConfig({ componentId: 'CommonWidget', displayName: 'KnockoutMobileContainer' })(
  'div',
  {
    position: 'relative',

    '> svg:nth-child(1)': {
      width: '10px',
      position: 'absolute',
      zIndex: 2,
      top: '17px',
      left: '30px',
    },
    '> svg:nth-child(1):hover': {
      color: 'orange',
      cursor: 'pointer',
      transition: 'color 0.3s',
    },
  },
);
